exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#horizontalbar-chart[data-v-01005c08] {\n\theight: 120px !important;\n}\n", ""]);

// exports
